import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getAdministrators} from '../../../actions/usersListActions';
import Icon from '../icon';
import './index.css';

function AccessDeniedPage () {

	const dispatch = useDispatch();

	const administrators = useSelector(state => state.usersListReducer.getAdministrators);

	useEffect(() => {
		dispatch(getAdministrators())
	}, [dispatch]);

	return (
		<div className="access-denied-page text-center p-5">
			<h2 className="text-danger">Administrator Role Required</h2>

			<p>The action you are trying to complete can be made only by the following administrator(s).</p>

			{
				administrators ? <ul>
					{
						administrators.administrators.map((admin) => (
							<li><a href={`mailto:${admin}`}>{admin}</a></li>
						))
					}
				</ul> : <p>
					<Icon animated={'pulse'} name="spinner"/>
				</p>
			}

			<p>They will need to either perform the action themselves or assign you the administrator role.</p>

			<a href='mailto:support@getsharedcontacts.com' className="btn btn-primary mt-3">Contact Support</a>
		</div>
	)
}

export default AccessDeniedPage;
